import type { LocateSkillMethod } from './types';

/**
 * Operator-facing name per locate method. Kept out of `locateMethodConfigs`:
 * that registry imports every step, so a step importing it back is a cycle.
 */
export const LOCATE_METHOD_LABELS: Record<LocateSkillMethod, string> = {
  dino_fast: 'ClickFind',
  text_prompt: 'TextFind',
  blob: 'Blob detection',
  shape_match: 'Shape detection',
  custom_checkpoint: 'Custom model',
  mock: 'Mock',
};
